import { FC } from 'react';

import { CircleLoaderStyled } from './CircleLoader.styled';

const CircleLoader: FC = () => <CircleLoaderStyled />;

export default CircleLoader;
